import { render, staticRenderFns } from "./vue-redactor.vue?vue&type=template&id=38cae0d3&"
import script from "./vue-redactor.vue?vue&type=script&lang=js&"
export * from "./vue-redactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports